import { weeklyRecap } from "@/mocks/daily";

const dayColor = ["bg-primary-500", "bg-secondary-500", "bg-accent-500"];

export default function Weekly() {
  return (
    <section id="recap" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-widest text-primary-600 uppercase">Week In Review</p>
            <h2 className="mt-2 font-serif text-2xl md:text-4xl font-black text-foreground-950">
              本周<span className="text-primary-500">盘点</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">按天回看本周值得记住的大事小情 · 文末附话题周榜</p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 text-xs text-foreground-600">
            <i className="ri-calendar-check-line text-secondary-600" aria-hidden="true"></i>
            2026.09.03 — 09.09
          </span>
        </div>

        <div className="relative mt-8">
          <span className="absolute left-[52px] top-2 bottom-2 hidden w-px bg-background-300 md:block" aria-hidden="true" />
          <div className="space-y-4">
            {weeklyRecap.map((e, i) => (
              <div key={e.day} className="relative flex items-stretch gap-4 md:gap-6">
                {/* 星期徽标 */}
                <div
                  className={`z-10 flex h-11 w-11 md:h-[52px] md:w-[52px] shrink-0 items-center justify-center rounded-full font-serif text-sm font-bold text-background-50 ${dayColor[i % 3]}`}
                >
                  {e.day.replace("周", "")}
                </div>
                <div className="min-w-0 flex-1 rounded-xl bg-background-50 border border-background-200 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                        e.mark ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-700"
                      }`}
                    >
                      {e.cat}
                    </span>
                    {e.mark && (
                      <span className="inline-flex items-center gap-1 text-[11px] font-medium text-accent-700">
                        <i className="ri-flag-2-fill" aria-hidden="true"></i>本周高光
                      </span>
                    )}
                  </div>
                  <h3 className="mt-2 font-serif text-base md:text-lg font-bold text-foreground-950">{e.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{e.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}